import React from 'react';
import { ArrowUp } from 'lucide-react';
import { motion } from 'framer-motion';

const FootnoteBackButton: React.FC = () => {
  const handleClick = (e: React.MouseEvent) => {
    e.preventDefault();
    const footnoteRef = document.getElementById('footnote-ref');
    if (footnoteRef) {
      footnoteRef.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <motion.button
      whileHover={{ scale: 1.1 }}
      whileTap={{ scale: 0.9 }}
      onClick={handleClick}
      className="ml-2 inline-flex items-center justify-center w-6 h-6 rounded-full bg-primary/10 hover:bg-primary/20 transition-colors"
    >
      <ArrowUp className="w-3 h-3 text-primary" />
    </motion.button>
  );
};

export default FootnoteBackButton;